import { useAuth0 } from 'bouncer';

const E2E_TEST_AUTHENTICATION_STATE = { isAuthenticated: true, isLoading: false, getIdTokenClaims: () => undefined };

export default function useAuthenticationState(appInfo) {
  const { profileName } = appInfo;
  const auth0AuthenticationState = useAuth0();

  if (profileName === 'e2e-test-authentication') {
    return E2E_TEST_AUTHENTICATION_STATE;
  }

  return auth0AuthenticationState;
}
